import { Injectable, Inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ArchiveService {
  constructor(@Inject('ServiceByType') private ServiceByType: any) {}

  archive(item: { type: string; id: number }): Promise<any> {
    const service = this.ServiceByType.get(item.type);
    if (typeof service.archive === 'function') {
      return service.archive(item.id);
    }
  }

  unarchive(item: { type: string; id: number }): Promise<any> {
    const service = this.ServiceByType.get(item.type);
    if (typeof service.publish === 'function') {
      return service.publish(item.id);
    }
  }
}
